import { render, staticRenderFns } from "./upkeep-alert-set.vue?vue&type=template&id=b1133dc0&scoped=true&"
import script from "./upkeep-alert-set.vue?vue&type=script&lang=ts&"
export * from "./upkeep-alert-set.vue?vue&type=script&lang=ts&"
import style0 from "./upkeep-alert-set.vue?vue&type=style&index=0&id=b1133dc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1133dc0",
  null
  
)

export default component.exports